import styled from 'styled-components';
import { Checkbox } from 'antd';

import 'antd/lib/checkbox/style';

export const CheckboxStyle = styled(Checkbox)`
    
`;
